// 售后详情页面
<template>
  <div class="sld_refund_detail" v-if="isShow">
    <div class="detail_top">
      <div class="title_content">售后管理</div>
	  <div class="sep"></div>
      <div class="step flex_row_center_center">          
            <div class="step_lines">
              <div class="step_line_item flex_row_center_center" :class="{active:stepLineIndex<=curStepIndex,noPass:afsInfo.data.state==603}" v-for="(stepLineItem,stepLineIndex) in  curStepTxt.data" :key="stepLineIndex">
                <img class="line" src="@/assets/order/step_line.png"  v-if='stepLineIndex>0'/>
                <div class="dot">
                  <div class="stepName flex_row_center_center">{{curStepTxt.data[stepLineIndex]}}</div>
                </div>						  
              </div>
            </div>
      </div>
      <div class="title_content">进度说明</div>
      <div class="sateInfo flex_row_start_center">
        <div class="stateValue">【{{afsInfo.data.stateValue}}】</div>
        <div class="stateTipTime flex_row_start_center" v-if='curStepValue==step.data.mail_receive_edit'>
          <div class="stateTip">{{afsInfo.data.stateDescPre}}</div>
          <div class=" stateTip time">{{afsInfo.data.buyerExpressEndTime}}</div>
          <div class="stateTip">{{afsInfo.data.stateDescSuffix}}</div>
        </div>
        <div class="stateTip" v-else>{{afsInfo.data.stateDesc}}</div>
      </div>
    </div>
  
    <div class="detail_bottom">
      	<div class="title_content">商品信息</div>
      	<div class="goods_title flex_row_start_center">
			<div class="title_name flex_row_center_center">商品名称</div>
			<div class="goods_sep"></div>
			<div class="title_prcie flex_row_center_center">单价</div>
			<div class="goods_sep "></div>
			<div class="title_num flex_row_center_center">数量</div>
      	</div>
      	<div class="afsProduct flex_row_start_center" v-for="(afsPItem,afsPIndex) in afsInfo.data.orderAfterServiceProductVOList" :key='afsPIndex'>
			<div class="goods flex_row_start_center">
				<img class="goodsImg" :src="afsPItem.productImage"/>
				<div class="goodsName">  <span class="p_tip" v-if='afsPItem.isGift||afsPItem.cartType==3'>{{afsPItem.isGift?'赠品':'搭配'}}</span>  {{afsPItem.productShortTitle}}</div>
			</div>
			<div class="price flex_row_center_center">￥{{afsPItem.returnMoneyAmount.toFixed(2) }}</div>   
			<div class="num flex_row_center_center">x{{afsPItem.returnNum }}</div>
      </div> 
	 	<div class="title_content">售后信息</div>	
	 	<div class="afs_detail">
		 <div class="d_item">
		 	<div class="di_name">订单编号：</div>
		 	<div class="di_content">{{afsInfo.data.orderSn}}</div>
		 <!-- 	<div class="di_copy" @click="onCopyTap(afsInfo.data.orderSn)">复制</div> -->
		 </div>
		 <div class="d_item">
		 	<div class="di_name">服务单号：</div>
		 	<div class="di_content">{{afsInfo.data.afsSn}}</div>
		 	<!-- <div class="di_copy" @click="onCopyTap(afsInfo.data.afsSn)">复制</div> -->
		 </div>
		 <div class="d_item">
		 	<div class="di_name">申请时间：</div>
		 	<div class="di_content">{{afsInfo.data.buyerApplyTime}}</div>					
		 </div>
		 <div class="d_item">
		 	<div class="di_name">售后类型：</div>
		 	<div class="di_content">{{afsInfo.data.afsTypeValue}}</div>					
		 </div>
		 <div class="d_item reason">
		 	<div class="di_name">售后原因：</div>
		 	<div class="di_content">{{afsInfo.data.applyReasonContent}}</div>
		 </div>
		 <div class="d_item" v-if='afsInfo.data.afsType!=2'>
		 	<div class="di_name">退款方式：</div>
		 	<div class="di_content">{{afsInfo.data.returnMoneyType==1?'':'原支付返还'}}</div>					
		 </div>
		 <template v-if="afsInfo.data.buyerExpressNumber">		 	
		 	<div class="d_item ">
		 		<div class="di_name">返件方式：</div>
		 		<div class="di_content">{{afsInfo.data.buyerReturnType==1?'自寄':'上门取件'}}</div>					
		 	</div>
		 	<div class="d_item reason">
		 		<div class="di_name">物流信息：</div>
		 		<div class="di_content">{{afsInfo.data.buyerExpressName}} {{afsInfo.data.buyerExpressNumber}}</div>					
		 	</div>
		 </template>
	 	</div> 
		<template v-if='curStepValue==step.data.mail_receive_edit'> 
			<div class="title_content big">商品退回方式</div>
			<div class="return_title flex_row_start_center">
				<!-- <div class="rt_item flex_row_center_center" :class="{active:curBuyerReturnType==2}">上门取件</div> -->
				<div class="rt_item flex_row_center_center zj " :class="{active:curBuyerReturnType==1}">自寄</div>
			</div>
			
			<div class="title_content big">确认信息</div>
			<div class="info_com margin_top20 flex_row_start_center">
				<div class="info_pre">快递公司：</div>
				<el-select-v2 v-model="curLogicsCompany" filterable :options="options" :placeholder="L['选择快递公司']"
				style="width: 250px;" :no-data-text="L['暂无数据']" />
			</div>
			<div class="info_bill margin_top20 flex_row_start_center">
				<div class="info_pre">快递单号：</div>
				<el-input :placeholder="L['输入物流单号']" style="width: 250px;" v-model="logisticsBill" maxlength="30">
				</el-input>
			</div>
			<div class="info_address flex_row_start_center"  v-if='afsInfo.data.afsType==2'>
				<!-- <img class="adr_img" src="@/assets/order/icon_checked.png">
				<div class="adr_tip">与首次收货地址一致</div> -->
				<div class="info_pre">收货地址：</div>
				<div class="adr_tip">与订单收货地址一致</div>
			</div>
			
			<div class="title_content big">退货寄回信息</div>
			<div class="thjh_item ">
				<div class="ti_name">联系人：</div>
				<div class="ti_content">{{afsInfo.data.storeAfsName}}</div>						
			</div>
			<div class="thjh_item ">
				<div class="ti_name">联系号码：</div>
				<div class="ti_content">{{afsInfo.data.storeAfsMobile}}</div>						
			</div>
			<div class="thjh_item">
				<div class="ti_name">寄回地址：</div>
				<div class="ti_content">{{afsInfo.data.storeAfsAddress}}</div>						
			</div>
		</template>	
		<div class="deal flex_row_end_center" v-if='afsInfo.data.afsType!=3&&curStepValue==step.data.mail_review'>			
			<div class="deal_cancel flex_row_center_center" @click="onCancelTap">取消售后</div>
		</div>		
		<div class="deal flex_row_end_center" v-else-if='curStepValue==step.data.mail_receive_edit'>			
			<div class="deal_confirm flex_row_center_center"   @click="onApplyTap" >提交</div>
			<div class="deal_cancel flex_row_center_center" @click="onCancelTap">取消售后</div>
		</div>
	</div>
  </div>
    <el-dialog  custom-class="cDlg"   v-model="cancelDialogVisible"   title="" width="269px" center :show-close="false" :align-center="true">
       <div class="cDlgContent">
         确认取消售后吗?
	   </div>
       <template #footer>
         <div class="dialog-footer">
           <el-button @click="cancelDialogVisible = false">取消</el-button>
           <el-button type="primary" @click="doCancel">
             确认
           </el-button>
         </div>
       </template>
     </el-dialog>
</template>

<script>
import { reactive, getCurrentInstance, ref, onMounted } from "vue";
import { ElMessage } from "element-plus";
import { useRoute, useRouter } from "vue-router";

export default {
  setup () {
    const { proxy } = getCurrentInstance();
    const L = proxy.$getCurLanguage();
    const route = useRoute();    
    const afsSn = ref(''); //售后单号
    const afsInfo = reactive({ data: {} }); //售后信息
    const LogisticsCompany=reactive({ data: {} });
	const curLogicsCompany = ref('') //当前物流公司名称
    const options = ref([])
    const curLCmpyIndex=ref(-1);//当前选择的物流公司index
    const curStepTxt=reactive({data:[]});//当前显示的stepTxt，根据状态进行选择
	const curStepIndex=ref(0);//当前step的index
	const curStepValue=ref(1);
	const logisticsBill = ref('') //物流单号
	const cancelDialogVisible = ref(false)
	const curBuyerReturnType=ref(1);//用户退货方式 1.自寄 2.上门取件
	const isShow=ref(false) //数据是否已完全加载
    /*定义步骤字段*/
    const step=reactive({data:{
			mail_review:1,//商城审核
			mail_receive_edit:20,//商城收货-用户填写单号等信息
			mail_receive:21,//商城收货
			mail_refund:3,//商城退款
			waiting_refund:4,//等待退款
			refund_completed:5,//退款完成
			mail_shipping:6,//商城发货，
			exchange_completed:7,//换货完成
			review_failed:8,//审核不通过
			afs_cancel:9,//售后取消
			afs_close:10,//售后关闭
			
		}});


	
    const router = useRouter()
    onMounted(() => { 
      afsSn.value = route.query.afsSn;     
      getRefundOrderDetail();
      getLogisticsCompany();
    });
    //获取售后订单详情
    const getRefundOrderDetail = () => {
      let params = {
        afsSn: afsSn.value
      }
      proxy.$post('v3/business/front/after/sale/detail', params,'json').then((res) => {

        //just for test
        //res=getTestAfsDetail()

        if (res.state == 200) {

          afsInfo.data = res.data;
          setStepInfo();
		/*需要指示具体时间*/
		if(curStepValue.value==step.data.mail_receive_edit)
		{
			if(res.data.stateDesc.includes('time')){
				var tmp=res.data.stateDesc.split('time')
				res.data.stateDescPre=tmp[0];
				res.data.stateDescSuffix=tmp[1];
			}
		}										
		
		isShow.value = true

        
        } else {
          ElMessage.error(res.msg)
        }
      })
    }
    //获取物流公司数据信息
    const getLogisticsCompany = () => {
      let params = {  }
      proxy.$get('v3/system/front/express/list', params).then((res) => {
      
        if (res.state == 200) {          
			LogisticsCompany.data = res.data.list
			options.value = LogisticsCompany.data.map(item => {
              return {
                value: item.expressId,
                label: item.expressName
              }
            })
        
        } else {
          ElMessage.error(res.msg)
        }
      })
    }
       /*仅退款： 100-买家申请仅退款（提交申请）；400-OMS同意仅退款申请(退款中)；401-OMS不同意仅退款申请(审核未通过)；500-财务同意退款申请；501-财务拒绝退款申请(待定状态)；
				
				退货退款状态：101-买家申请退货退款（提交申请）；200-客服同意退款申请（商城审核通过）；201-客服拒绝退款申请(审核未通过)；
				300-OMS同意用户退货(拦截失败用户填写快递信息)；301-买家退货给商家(买家填完快递信息)；302-OMS确认收货(退款中)；
				303-OMS验货原因拒绝退货退款申请(售后关闭)；304-用户7天内未提交售后取消(售后取消)；500-财务同意退款申请(已完成)；501-财务拒绝退款申请(待定状态)；
				
				换货：102-买家申请换货（提交申请）；200-客服同意退款申请（商城审核通过）；201-客服拒绝退款申请(审核未通过)；301-买家退货给商家(买家填完快递信息)；
				302-OMS确认收货；303-OMS验货原因拒绝退货退款申请(售后关闭)；304-7天内未提交售后取消(售后取消)；305-换货OMS发货；502-换货买家收货(已完成)
				通用状态：600-退款完成 601-退款取消 602-退款关闭
			*/
		const setStepInfo=()=>{
				var state=afsInfo.data.state;
				var afsType=afsInfo.data.afsType;//售后服务端类型：1-退货退款单，2-换货单，3-仅退款单
				/*暂时这样*/
				var tmpStepTxt=[]
				var tmpIndex=0;			  
				var tmpVaule=step.data.mail_review
				if(afsType==3){ //仅退款单
					if(state!=603){
						tmpStepTxt=[
							"提交申请",
							"商城审核",
							"等待退款",
							"退款完成",
						 ]
						 let indexInfo={
						 	100:{index:1,value:step.data.mail_review},						
						 	400:{index:2,value:step.data.waiting_refund},
						 	500:{index:2,value:step.data.waiting_refund},						 	
						 	600:{index:3,value:step.data.refund_completed},
						 }
						 tmpIndex=indexInfo[state].index;
						 tmpVaule=indexInfo[state].value;
						 
					}else{
						tmpStepTxt=[
							"提交申请",
							"商城审核",
							"审核不通过",						
						]
						tmpIndex=2
						tmpVaule=step.data.review_failed;
					}
					
				}
				else if(afsType==1){ //退货退款
					if(state==603||state==601||state==602){
						tmpStepTxt=[
							"提交申请",
							"商城审核",
							"审核不通过",						
						]
						tmpVaule=step.data.review_failed;
						if(state==601){
							tmpStepTxt[2]='售后取消'
							tmpVaule=step.data.afs_cancel;
						}else if(state==602){
							tmpStepTxt[2]='商城收货'
							tmpStepTxt.push('售后关闭')
							tmpVaule=step.data.afs_close;
							
						}
						tmpIndex=tmpStepTxt.length-1;
						
					}else {
						tmpStepTxt=[
							"提交申请",
							"商城审核",
							"商城收货",
							"等待退款",
							"退款完成"
						]
						let indexInfo={
							101:{index:1,value:step.data.mail_review},
							200:{index:1,value:step.data.mail_review},
							300:{index:2,value:step.data.mail_receive_edit},
							301:{index:2,value:step.data.mail_receive},
							302:{index:3,value:step.data.waiting_refund},
							500:{index:3,value:step.data.waiting_refund},
							600:{index:4,value:step.data.refund_completed},
						}					
						tmpIndex=indexInfo[state].index;
						tmpVaule=indexInfo[state].value;
					}
				}else if(afsType==2){//换货
					if(state==603||state==601||state==602){
						
						tmpStepTxt=[
							"提交申请",
							"商城审核",
							"审核不通过",						
						]
						tmpVaule=step.data.review_failed;
						if(state==601){
							tmpStepTxt[2]='售后取消'
							tmpVaule=step.data.afs_cancel;
						}else if(state==602){
							tmpStepTxt[2]='商城收货'
							tmpStepTxt.push('售后关闭')
							tmpVaule=step.data.afs_close;							
						}
						tmpIndex=tmpStepTxt.length-1;
					}else{
						tmpStepTxt=[
							"提交申请",
							"商城审核",
							"商城收货",
							"商城发货",
							"换货完成"
						]
						let indexInfo={
							102:{index:1,value:step.data.mail_review},						
							200:{index:2,value:step.data.mail_review},	
							300:{index:2,value:step.data.mail_receive_edit},
							301:{index:2,value:step.data.mail_receive},	
							302:{index:2,value:step.data.mail_receive},
							305:{index:3,value:step.data.mail_shipping},
							600:{index:4,value:step.data.exchange_completed},
						}
						
						tmpIndex=indexInfo[state].index;
						tmpVaule=indexInfo[state].value;
					}
				}
				curStepValue.value=tmpVaule;
				curStepTxt.data=tmpStepTxt;
				curStepIndex.value=tmpIndex;
		}
	const onCancelTap=()=>{
		cancelDialogVisible.value=true;
	}
	const doCancel=()=>{
		cancelDialogVisible.value=false;
		let params = {
		  afsSn: afsSn.value
		}
		proxy.$post('v3/business/front/after/sale/cancel', params,'json').then((res) => {
		  if (res.state == 200) {          
				getRefundOrderDetail()		  
		  } else {
		    ElMessage.error(res.msg)
		  }
		})
		
	}
	const onApplyTap=()=>{
		// if(!curLogicsCompany.value||!logisticsBill.value){
		// 	  ElMessage("信息填写不完整")
		// 	  return
		// }
	 if (curLogicsCompany.value == '') {
        ElMessage(L['请选择快递公司!'])
        return
      }
      if (logisticsBill.value == '') {
        ElMessage(L['请输入快递单号！'])
        return
      }
      let reg = /^[0-9a-zA-Z]{1,20}$/g
      if (!reg.test(logisticsBill.value)) {
        ElMessage(L['请输入正确的快递单号！'])
        return
      }
		let params = {
		  afsSn: afsSn.value,
		  buyerReturnType:curBuyerReturnType.value,
		  logisticsNumber:logisticsBill.value,
		  expressId:curLogicsCompany.value
		}
		proxy.$post('v3/business/front/after/sale/deliverGoods', params,'json').then((res) => {
		  if (res.state == 200) {          
			getRefundOrderDetail()	  
		  } else {
		    ElMessage.error(res.msg)
		  }
		})
		
	}
    const getTestAfsDetail=()=>{
				return {
					"data": {					
							
						"afsDescription": "",
						"afsLogList": [
							{
								"content": "",
								"createTime": "",
								"logId": 0,
								"state": ""
							}
						],
						"afsSn": "100",
						"afsType": 2,//售后服务端类型：1-退货退款单，2-换货单，3-仅退款单
						"afsTypeValue": "换货",//退款方式值：1-退货退款，2-换货，3-仅退款
						"applyReasonContent": "发错了发错了发错了发错了发错了发错了发错了发错了发错了发错",//申请售后服务原因
						"buyerApplyTime": "2024-08-30  12:22:22",//申请时间
						"buyerExpressCode": "123",//用户换件/退件物流公司快递代码
						"buyerExpressName": "顺风速递顺风速递顺风速递顺风速递顺风速递",//用户换件/退件物流公司
						"buyerExpressNumber": "",//用户换件/退件快递单号
						"commissionAmount": 0,//
						"commissionRate": 0,
						"deductIntegralAmount": 0,
						"memberId": 0,
						"memberName": "",
						"orderAfterServiceProductVOList": [
							{
								cartType:1, //类型：1-主商品、2-增值服务、3-加价购
								isGift:1,//
								"goodsId": 10,
								"productShortTitle": "灵耀X双屏Pro 标压酷睿 双4K触控屏 高性能创作笔记高性能创作笔记双4K触控屏 高性能创作笔记高性能创作笔记双4K触控屏 高性能创作笔记高性能创作笔记",
								"productId": 0,
								"productImage": "https://accali-dev-rog-mall.oss-cn-shanghai.aliyuncs.com/bbcimages/seller/goods/T7XrAGvk09uqu3sFsv5.jpg?bindId=68",
								"returnMoneyAmount": 200,
								"returnNum": 2,
								"specValues": "蓝色"
							}
						],
						"orderSn": "123566767",
						"orderState": 0,
						"refuseReason": "",//拒绝原因
						"returnCouponCode": "",
						"returnExpressAmount": 0,
						"returnIntegralAmount": 0,
						"returnMoneyAmount": 0,
						"returnMoneyType": 0,//退款方式：0-原路退回，1-退账户余额
						"returnTypeValue":'',
						"returnVoucherCode": "",
						buyerExpressEndTime:'2024-11-08 13:58:58',
						buyerReturnType:1,// 用户退货方式 1.自寄 2.上门取件
						"state": 300, //退货/退款状态：100-买家申请仅退款；101-买家申请退货退款；102-买家退货给商家；200-商家同意退款申请；201-商家同意退货退款申请；202-商家拒绝退款申请(退款关闭/拒收关闭)；203-商家确认收货；300-平台确认退款(已完成)。换货状态：100-买家申请；101-买家发货；200-卖家审核失败；201-卖家审核通过；202-卖家确认收货；203-卖家拒收；204-卖家发货；301-买家收货（已完成）
						"stateValue": "审核中",
						"stateDesc":'商家会尽快time处理，请耐心等候',
						"storeAfsAddress": "上海市上海市上海市闵行区金都路5077号5楼3层",//商户售后地址
						"storeAfsMobile": "13585744432",//商户联系电话
						"storeAfsName": "李先生",//商户联系人
						"storeId": 0,
						"storeName": "",
						"storeRemark": ""
					},
					"msg": "",
					"state": 200,
					"timestamp": 0
				}
			}
   

    return {
      	L,    
		afsSn,
		afsInfo,
		LogisticsCompany,
		curStepTxt,
		curStepIndex,
		curStepValue,
		curLCmpyIndex,
		step,
		curLogicsCompany,
      	logisticsBill,
      	options,
		onCancelTap,
		doCancel,
		onApplyTap,
		cancelDialogVisible,
		curBuyerReturnType,
		isShow
		
    };
  },
};
</script>

<style lang="scss" scoped>
	@import "../../../style/base.scss";
	@import "../../../style/iconfont.css";
	@import "../../../style/refundDetail.scss";

	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
	-webkit-appearance: none;
	}

	input[type='number'] {
	-moz-appearance: textfield;
	}

	.cDlgContent{
		display: flex;
		align-items: center;
		justify-content: center;
		font-family: Microsoft YaHei ;
		font-weight: bold;
		font-size: 15px;
	}
	
</style>

<style lang="scss">
	.cDlg{
		.el-dialog__body {
			padding-top: 20px !important;
			padding-bottom: 30px !important;
		}
		.el-dialog__header{
			display: none;
		}
	}
</style>

